<template lang="pug">
  b-tooltip.task-status(v-if="status" :position="tooltipPosition" :label="status.name" :active="iconOnly" :type="componentType")
    b-icon(:icon="status.icon" :type="iconType")
    small.ml-5(v-if="!iconOnly") {{ status.name }}
</template>

<script>
export default {
  name: 'task-status',

  props: {
    status: Object,
    iconOnly: Boolean,
    altStyle: Boolean,

    tooltipPosition: {
      type: String,
      default: () => 'is-top',
    },
  },

  computed: {
    iconType() {
      return this.altStyle ? null : this.status.color;
    },
    componentType() {
      return this.altStyle ? this.status.color : 'is-white';
    },
  },
};
</script>
